import { BrandConfig } from './brand.types';

export const BRAND_CONFIG: BrandConfig = {
  // ME (Maine) brand configuration
  logoPath: 'assets/images/logo_me.svg',
  logoAlt: 'CoverME.gov Site logo',
  faviconPath: 'assets/favicon_me.png',
  brandName: 'CoverME.gov',
  rosterTemplatePath: 'assets/roster_upload_template_me.xlsx',
  zipCodeDataPath: 'data/zipCodeME.json',
};
